// src/pages/Users/EditCommissionModal.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const EditCommissionModal = ({ show, onClose, onSubmit, user }) => {
  const [commissionRate, setCommissionRate] = useState('');
  const [reason, setReason] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (user) {
      setCommissionRate(user.commissionRate?.toString() || '0');
      setReason('');
    }
  }, [user]);

  const validate = () => {
    const newErrors = {};
    const rate = parseFloat(commissionRate);
    
    if (isNaN(rate) || rate < 0 || rate > 100) {
      newErrors.commissionRate = 'Commission rate must be between 0 and 100';
    }
    
    if (!reason.trim()) {
      newErrors.reason = 'Please provide a reason for changing commission';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onSubmit(user._id, parseFloat(commissionRate), reason);
    }
  };

  if (!user) return null;

  return (
    <Modal show={show} onHide={onClose} centered size="md">
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title>
          <i className="fas fa-percentage me-2"></i>
          Edit Commission - {user.username}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label fw-bold">Current Commission Rate</label>
            <div className="alert alert-info mb-0">
              <strong>{user.commissionRate || 0}%</strong>
            </div>
          </div>
          
          <div className="mb-3">
            <label className="form-label fw-bold">New Commission Rate (%)</label>
            <input
              type="number"
              className={`form-control ${errors.commissionRate ? 'is-invalid' : ''}`}
              value={commissionRate}
              onChange={(e) => setCommissionRate(e.target.value)}
              step="0.1"
              min="0"
              max="100"
              required
            />
            {errors.commissionRate && (
              <div className="invalid-feedback">{errors.commissionRate}</div>
            )}
            <small className="text-muted">
              Enter commission rate between 0% and 100%
            </small>
          </div>
          
          <div className="mb-3">
            <label className="form-label fw-bold">Reason for Change</label>
            <textarea
              className={`form-control ${errors.reason ? 'is-invalid' : ''}`}
              rows="3"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Why are you changing this user's commission rate?"
              required
            />
            {errors.reason && (
              <div className="invalid-feedback">{errors.reason}</div>
            )}
            <small className="text-muted">
              This reason will be recorded in the commission history
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            <i className="fas fa-save me-1"></i>
            Update Commission
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditCommissionModal;